module.exports = __webpack_public_path__ + "636100a78eda5b52970a7093de85b270.mp4";